import { PlateCodes } from "src/utils/interfaces/interfaces";

export const UAEPrivatePlateCodes: PlateCodes = {
  'AE-AZ': [
    { code: 'Blue', name: 'Blue' },
    { code: 'Gray', name: 'Gray' },
    { code: 'Green', name: 'Green' },
    { code: 'Red', name: 'Red' },
    { code: '1', name: '1' },
    { code: '2', name: '2' },
    { code: '4', name: '4' },
    { code: '5', name: '5' },
    { code: '6', name: '6' },
    { code: '7', name: '7' },
    { code: '8', name: '8' },
    { code: '9', name: '9' },
    { code: '10', name: '10' },
    { code: '11', name: '11' },
    { code: '12', name: '12' },
    { code: '13', name: '13' },
    { code: '14', name: '14' },
    { code: '15', name: '15' },
    { code: '16', name: '16' },
    { code: '17', name: '17' },
    { code: '18', name: '18' },
    { code: '19', name: '19' },
    { code: '20', name: '20' },
    { code: '21', name: '21' },
    { code: '22', name: '22' },
    { code: '50', name: '50' },
  ],
  'AE-AJ': [
    { code: 'A', name: 'A' },
    { code: 'B', name: 'B' },
    { code: 'C', name: 'C' },
    { code: 'D', name: 'D' },
    { code: 'E', name: 'E' },
    { code: 'F', name: 'F' },
    { code: 'H', name: 'H' },
    { code: 'K', name: 'K' },
  ],
  'AE-DU': [
    { code: 'A', name: 'A' },
    { code: 'B', name: 'B' },
    { code: 'C', name: 'C' },
    { code: 'D', name: 'D' },
    { code: 'E', name: 'E' },
    { code: 'F', name: 'F' },
    { code: 'G', name: 'G' },
    { code: 'H', name: 'H' },
    { code: 'I', name: 'I' },
    { code: 'J', name: 'J' },
    { code: 'K', name: 'K' },
    { code: 'L', name: 'L' },
    { code: 'M', name: 'M' },
    { code: 'N', name: 'N' },
    { code: 'O', name: 'O' },
    { code: 'P', name: 'P' },
    { code: 'Q', name: 'Q' },
    { code: 'R', name: 'R' },
    { code: 'S', name: 'S' },
    { code: 'T', name: 'T' },
    { code: 'U', name: 'U' },
    { code: 'V', name: 'V' },
    { code: 'W', name: 'W' },
    { code: 'X', name: 'X' },
    { code: 'Y', name: 'Y' },
    { code: 'Z', name: 'Z' },
    { code: 'AA', name: 'AA' },
    { code: 'BB', name: 'BB' },
    { code: 'CC', name: 'CC' },
    { code: 'DD', name: 'DD' },
    { code: 'EE', name: 'EE' },
    { code: 'FF', name: 'FF' },
    { code: 'HH', name: 'HH' },
    { code: 'II', name: 'II' },
    { code: 'MM', name: 'MM' },
    { code: 'NN', name: 'NN' },
    { code: 'WHITE', name: 'WHITE' },
  ],
  'AE-FU': [
    { code: 'A', name: 'A' },
    { code: 'B', name: 'B' },
    { code: 'C', name: 'C' },
    { code: 'D', name: 'D' },
    { code: 'E', name: 'E' },
    { code: 'F', name: 'F' },
    { code: 'G', name: 'G' },
    { code: 'H', name: 'H' },
    { code: 'I', name: 'I' },
    { code: 'J', name: 'J' },
    { code: 'K', name: 'K' },
    { code: 'L', name: 'L' },
    { code: 'M', name: 'M' },
    { code: 'N', name: 'N' },
    { code: 'O', name: 'O' },
    { code: 'P', name: 'P' },
    { code: 'R', name: 'R' },
    { code: 'S', name: 'S' },
    { code: 'T', name: 'T' },
    { code: 'U', name: 'U' },
    { code: 'V', name: 'V' },
    { code: 'X', name: 'X' },
    { code: 'Y', name: 'Y' },
    { code: 'Z', name: 'Z' },
    { code: 'White', name: 'White' },
  ],
  'AE-RK': [
    { code: 'A', name: 'A' },
    { code: 'B', name: 'B' },
    { code: 'C', name: 'C' },
    { code: 'D', name: 'D' },
    { code: 'F', name: 'F' },
    { code: 'G', name: 'G' },
    { code: 'I', name: 'I' },
    { code: 'K', name: 'K' },
    { code: 'M', name: 'M' },
    { code: 'N', name: 'N' },
    { code: 'P', name: 'P' },
    { code: 'S', name: 'S' },
    { code: 'U', name: 'U' },
    { code: 'V', name: 'V' },
    { code: 'X', name: 'X' },
    { code: 'Y', name: 'Y' },
    { code: 'Z', name: 'Z' },
    { code: '1', name: '1' },
    { code: 'Qala', name: 'Qala' },
    { code: 'RAK-Tower', name: 'RAK-Tower' },
    { code: 'White', name: 'White' },
  ],
  'AE-SH': [
    { code: 'Blue', name: 'Blue' },
    { code: 'Orange', name: 'Orange' },
    { code: 'White', name: 'White' },
    { code: 'White+Blue', name: 'White+Blue' },
    { code: 'Yellow', name: 'Yellow' },
    { code: '1', name: '1' },
    { code: '2', name: '2' },
    { code: '3', name: '3' },
    { code: '4', name: '4' },
    { code: '7', name: '7' },
  ],
  'AE-UQ': [
    { code: 'A', name: 'A' },
    { code: 'B', name: 'B' },
    { code: 'C', name: 'C' },
    { code: 'D', name: 'D' },
    { code: 'E', name: 'E' },
    { code: 'F', name: 'F' },
    { code: 'G', name: 'G' },
    { code: 'H', name: 'H' },
    { code: 'I', name: 'I' },
    { code: 'J', name: 'J' },
    { code: 'K', name: 'K' },
    { code: 'L', name: 'L' },
    { code: 'M', name: 'M' },
    { code: 'N', name: 'N' },
    { code: 'X', name: 'X' },
    { code: 'White', name: 'White' },
  ],
  '': []
};

export const UAEPublicPlateCodes = {
  'AE-FU': [
    { code: 'Green', name: 'Green' },
  ],
};


export const PrivateRegType = "private";
export const RegistrationType = [
  { name: "Private", code: PrivateRegType },
  { name: "Public", code: "public" },
];